import API from '../Services/API';
import Model from './Model';

const useAccount = (alwaysRefresh = false) => {
    return Model({
        stateKey: 'voip-account',
        alwaysRefresh: alwaysRefresh,
        fetchData: (r) => API.get('/voip/account'),
        returnDataKey: 'account',
        registerAdditionalMethods: (opts) => {
            return {
                updateCustomSMSName: (customSMSName) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/voip/updateCustomSMSName', { customSMSName }),
                        'Custom SMS name updated',
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading some data.',
    })
}

export {
    useAccount,
}
